import {
  ChevronLeftIcon,
  ChevronRightIcon,
  FontSizeEnum,
  IconSizeEnum,
  Typography,
} from '@acceso/design-system';
import clsx from 'clsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import { useNavigationKeywords } from '@/features/broadcast-schedule-program/hooks/useNavigationKeywords';

export function SegmentDetailNavigation() {
  const { activeSegment, segmentItems, setActiveSegment, setVisibleBox } =
    useBroadcastScheduleProgram();
  const { t } = useTranslation();

  const hasNextItem = useMemo(() => {
    if (!activeSegment) return false;
    return segmentItems.findIndex(item => item.id === activeSegment.id) !== segmentItems.length - 1;
  }, [activeSegment, segmentItems]);

  const hasPreviousItem = useMemo(() => {
    if (!activeSegment) return false;
    return segmentItems.findIndex(item => item.id === activeSegment.id) > 0;
  }, [activeSegment, segmentItems]);

  const handleNext = () => {
    setVisibleBox(null);

    if (!activeSegment) return;
    const currentIndex = segmentItems.findIndex(item => item.id === activeSegment.id);

    if (currentIndex === -1 || currentIndex === segmentItems.length - 1) return;

    const nextItem = segmentItems[currentIndex + 1];

    if (nextItem) {
      setActiveSegment(nextItem);
    }
  };

  const handlePrevious = () => {
    setVisibleBox(null);

    if (!activeSegment) return;

    const currentIndex = segmentItems.findIndex(item => item.id === activeSegment.id);

    if (currentIndex === -1 || currentIndex === 0) return;

    const previousItem = segmentItems[currentIndex - 1];

    if (previousItem) {
      setActiveSegment(previousItem);
    }
  };

  useNavigationKeywords({
    handleClickNextUi: handleNext,
    handleClickPrevUi: handlePrevious,
    shortcutsDisabled: false,
  });

  return (
    <div
      className={clsx(
        'sticky bottom-0 flex justify-between bg-white py-2',
        !hasPreviousItem && '!justify-end'
      )}
    >
      {hasPreviousItem && (
        <div className="flex cursor-pointer items-center gap-2" onClick={handlePrevious}>
          <ChevronLeftIcon size={IconSizeEnum.SM} />
          <Typography fontSize={FontSizeEnum.Basic}>{t('Anterior')}</Typography>
        </div>
      )}
      {hasNextItem && (
        <div onClick={handleNext} className="flex cursor-pointer items-center justify-end gap-2">
          <Typography fontSize={FontSizeEnum.Basic}>{t('Siguiente')}</Typography>
          <ChevronRightIcon size={IconSizeEnum.SM} />
        </div>
      )}
    </div>
  );
}
